import React, { useLayoutEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ApiProxyGroup from "../../../app/api/admin/proxy-group/ApiProxyGroup";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import useListFilters from "../../modules/list/useListFilters";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import ButtonLinkShow from "../../components/button-link/__show";
import ButtonLinkAdd from "../../components/button-link/__add";
import InputText from "../../components/inputs/text";
import Select from "../../components/inputs/select";
import { useSelector } from "react-redux";
import ApiAppInit from "../../../app/api/admin/system/ApiAppInit";
import { formatGroupDate, groupProxiesUrl } from "./group";

// Список групп прокси (authorized/admin/proxy-groups): сортировка — по ProxyGroupFilter (id / name /
// expires_at / proxies_count / nodes_count / created_at), по умолчанию — по названию.
export default function ProxyGroupsIndex({ ...other }) {
    return <Page {...other}>
        <ProxyGroupsIndexContent/>
    </Page>;
}

function ProxyGroupsIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);
    const nodes = useSelector((state) => state.option.nodes);

    // Фильтры — в URL (useListFilters), как в остальных списках.
    const filter = useListFilters(['name', 'node_id']);

    useLayoutEffect(() => {
        contextContent.setTitle('Группы прокси');
        // Сюда возвращаются после создания / переименования / удаления группы — освежаем
        // справочник групп, чтобы подписи в выпадающих списках других разделов были актуальны.
        ApiAppInit.ReloadProxyGroups();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const header = [
        <ListHeaderItem key="id" name="id">ID</ListHeaderItem>,
        <ListHeaderItem key="name" name="name">Название</ListHeaderItem>,
        <ListHeaderItem key="expires_at" name="expires_at">До</ListHeaderItem>,
        <ListHeaderItem key="proxies_count" name="proxies_count">Прокси</ListHeaderItem>,
        <ListHeaderItem key="nodes_count" name="nodes_count">Нод</ListHeaderItem>,
        <ListHeaderItem key="create" name="create" isSort={false}>
            {contextContent.checkPermission('create')
                ? <ButtonLinkAdd className="button-link_white" title="Добавить" href={contextPage.routes.create.url()}/> : null}
        </ListHeaderItem>,
    ];

    const filters = [
        <InputText className="input_wf" value={filter.values.name}
            onChange={(e) => filter.setValue('name', e.target.value)}>Название</InputText>,
        <Select className="input_wf" options={nodes} value={filter.values.node_id} isNull={true}
            onChange={(e) => filter.setValue('node_id', e.target.value)}>Нода</Select>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="id">{row.id}</ListBodyItem>,
        <ListBodyItem key="name">{row.name}</ListBodyItem>,
        <ListBodyItem key="expires_at">{formatGroupDate(row.expires_at)}</ListBodyItem>,
        <ListBodyItem key="proxies_count">
            {row.proxies_count > 0
                ? <Link to={groupProxiesUrl(row.id)} title="Прокси группы">{row.proxies_count}</Link>
                : 0}
        </ListBodyItem>,
        <ListBodyItem key="nodes_count">{row.nodes_count ?? 0}</ListBodyItem>,
        <ListBodyItem key="show">
            {contextContent.checkPermission('show')
                ? <ButtonLinkShow className="button-link_blue" title="Просмотр" href={contextPage.routes.show.url({ id: row.id })}/> : null}
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiProxyGroup}
        renderRow={renderRow}
        filters={filters}
        defaultSortKey="name"
        defaultSortIsAsc={true}
        searchParams={filter.applied}
        onApplyFilters={filter.apply}
        onResetFilters={filter.reset}
    />;
}
